import React from "react";
import { Link, useLocation } from "react-router-dom";
import { pathToRegexp } from "path-to-regexp";

export default function NavLink({
  href,
  exact,
  activeClassName = "active",
  children,
  ...props
}) {
  let location = useLocation();

  const isActive = pathToRegexp(href, [], {
    sensitive: true,
    end: !!exact,
  }).test(location.pathname);

  const child = React.Children.only(children);

  return (
    <Link
      to={href}
      {...props}
      className={`${props.className} ${isActive ? activeClassName : ""}`}
    >
      {child}
    </Link>
  );
}
